import { render, staticRenderFns } from "./DashboardMonthlyChart.vue?vue&type=template&id=0aadeb1d"
import script from "./DashboardMonthlyChart.vue?vue&type=script&lang=js"
export * from "./DashboardMonthlyChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports